'use strict';

const { h } = require('phy');

const Header = require('../../shared/views/header');
const RedemptionProvider = require('../../redemption/views/redemption-provider');
const MainTitle = require('../../coupons/views/main-title');
const CouponsList = require('../../coupons/views/coupons-list');
const Carousel = require('../../shared/views/carousel');
const SidebarBrowseLetter = require('../../merchant/views/sidebar-browse-letter');

function getCarouselOptions(coupons) {
  return {
    className: 'carousel-sidebar',
    coupons,
    autoplay: true,
    navigation: false,
    options: {
      perPage: 1,
    },
  };
}

function ExclusiveOffers({ payload, deps }) {
  const {
    keyAuthData,
    seoMetaData: { h1Override },
    navigationMerchants,
    couponsForList,
    advertsForCarousel,
  } = payload;
  const { routes } = deps;

  return h('article', [
    h(RedemptionProvider, { routes }),
    h(Header, {
      routes,
      activePage: 'exclusive-offers',
      keyAuthData,
      merchants: navigationMerchants,
    }),
    h('section.container', [
      h('.layout', [
        h(
          '.layout-content',
          {
            'data-bhw': 'ExclusiveCouponsList',
          },
          [
            h(MainTitle, {
              h1Override,
              resourceKey: '.PageHeading',
            }),
            h(CouponsList, { coupons: couponsForList, routes }),
          ]
        ),
        h('.layout-sidebar', [
          advertsForCarousel &&
            advertsForCarousel.length > 0 &&
            h(
              '.carousel-container',
              Carousel({ routes, ...getCarouselOptions(advertsForCarousel) })
            ),
          h(SidebarBrowseLetter, { routes }),
        ]),
      ]),
    ]),
  ]);
}

module.exports = ExclusiveOffers;
